const routes = {
  root: '/course/details',
}

export default routes
